import React from "react";
import Textbox from "../../../components/Textbox";
import CheckBox from "../../../components/Checkbox/Checkbox";

const MigrationForm = (props: any) => {
  const { values, handleChange, errors, touched, check, shopId } = props;
  return (
    <div>
      <div className="subtitle clearfix">
        <h2 className="title2">Migration Wizard</h2>
      </div>
      <div className="row">
        <div className="col-md-6">
          <Textbox
            name="from_shop_username"
            placeholder="Enter From Shop Name"
            value={values.from_shop_username}
            onChange={handleChange}
            label="From Shop username"
            errorMessage={
              touched.from_shop_username && errors.from_shop_username
            }
          />
        </div>
        <div className="col-md-6">
          <Textbox
            name="to_shop_username"
            placeholder="Enter To Shop Name"
            value={values.to_shop_username}
            onChange={handleChange}
            label="To Shop Username"
            errorMessage={touched.to_shop_username && errors.to_shop_username}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 mt-4 pl-4">
          <CheckBox
            name="category"
            label="Migrate Category"
            onChange={handleChange}
            checked={values.category}
          />
        </div>
        <div className="col-md-4 mt-4">
          <CheckBox
            name="diningtable"
            label="Migrate Tables"
            onChange={handleChange}
            checked={values.diningtable}
          />
        </div>
        <div className="col-md-4 mt-4 pl-4">
          <CheckBox
            name="fooditem"
            label="Migrate Fooditem"
            onChange={handleChange}
            checked={values.fooditem}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 mt-4 pl-4">
          <CheckBox
            name="expense_category"
            label="Migrate Expense Category"
            onChange={handleChange}
            checked={values.expense_category}
          />
        </div>
        <div className="col-md-4 mt-4">
          <CheckBox
            name="inventory_category"
            label="Migrate Inventory Category"
            onChange={handleChange}
            checked={values.inventory_category}
          />
        </div>
      </div>
    </div>
  );
};

export default MigrationForm;
